(function () {
    'use strict';

    angular
        .module('app.campaignActivity')
        .config(['$stateProvider', '$urlRouterProvider', function ($stateProvider) {
            $stateProvider.state('home.campaignActivityPage', {
                requireLogin: true,
                url: 'campaign/activity/:campaign_influencer_id',
                templateUrl: 'app/campaign/campaignActivityPage/campaignActivityPage.html?app_v=deployDate',
                data: {
                    authorizedRoles: ['User', 'Administrator'],
                    navMarker: ['campaign', 'index']
                },
                controller: 'campaignActivityPageCtrl',
                params: {
                    campaign_id: null,
                    campaign_style: null
                }
            });
        }])
})();

